import React, { ChangeEvent } from 'react';
import { observer } from 'mobx-react';
import { observable, action, computed } from 'mobx';
import intl from 'react-intl-universal';
import ExhibitorStyleSearch from './ExhibitorStyleSearch';

interface ISearchRow {
  search?: (input: string) => void;
  clear?: () => void;
  placeholder?: string;
  h1Color?: string;
  h2Color?: string;
  mainColor?: string;
}
@observer
class SearchRow extends React.Component<ISearchRow> {
  @observable input = '';
  @action changeInput = (e: ChangeEvent<HTMLInputElement>) => {
    this.input = e.target.value;
  };
  @computed get active() {
    return !!this.input;
  }
  @action clear = () => {
    this.input = '';
    this.props.clear && this.props.clear();
  };
  search = () => {
    const { input } = this;
    if (!input) {
      console.warn('没有输入');
      this.props.clear && this.props.clear();
      return;
    }
    this.props.search && this.props.search(input);
  };
  render() {
    return (
      <ExhibitorStyleSearch
        placeholder={
          this.props.placeholder ||
          intl.get('Enter your participate no., letters included')
        }
        value={this.input}
        onChange={this.changeInput}
        onSearch={this.search}
      />
    );
  }
}

export default SearchRow;
